/**
 * Alarmas de contrato — Iter279 (feedback delegados: "alarmas para aquellos
 * contratos que le quedan 2 años para finalizar superiores a 1M€").
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, AlarmClock } from "lucide-react";
import { API } from "@/context/AuthContext";

const fmtEur = (n) =>
  n == null ? "—" :
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

const urgencyColor = (dias) => (dias <= 180 ? "text-rose-600 bg-rose-50" : dias <= 365 ? "text-amber-600 bg-amber-50" : "text-emerald-600 bg-emerald-50");

export default function AlarmasContrato() {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/delegado/oportunidades/alarmas-contratos`)
      .then((r) => setItems(r.data.items))
      .catch(() => toast.error("No se pudieron cargar las alarmas de contrato"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-16 text-slate-400" data-testid="delegado-alarmas-loading"><Loader2 className="animate-spin mx-auto mb-2" size={24} />Cargando alarmas…</div>;

  if (!items || items.length === 0) {
    return <p className="text-sm text-slate-400 text-center py-10" data-testid="delegado-alarmas-empty">Ningún contrato de tu zona vence en los próximos 2 años por más de 1M€.</p>;
  }

  return (
    <div className="space-y-2" data-testid="delegado-alarmas-list">
      <p className="text-xs text-slate-500 mb-2">Contratos &gt;1M€ de tu zona que finalizan en menos de 2 años (estimación, revísalos para preparar la renovación con tiempo).</p>
      {items.map((it, i) => (
        <div key={i} className="bg-white border border-slate-200 rounded-xl p-3" data-testid={`delegado-alarma-item-${i}`}>
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-slate-800 line-clamp-1">{it.cliente}</p>
              <p className="text-xs text-slate-500 line-clamp-2 mt-0.5">{it.objeto}</p>
            </div>
            <span className={`text-xs font-bold px-2 py-1 rounded-full whitespace-nowrap ${urgencyColor(it.dias_restantes)}`}>
              <AlarmClock size={11} className="inline mr-1" />{it.dias_restantes}d
            </span>
          </div>
          <div className="flex items-center gap-3 mt-2 text-[11px] text-slate-500">
            <span className="font-semibold text-slate-700">{fmtEur(it.valor_eur)}</span>
            <span>Adjudicatario actual: {it.winner || "—"}</span>
            <span>Vence ~{it.proxima_licitacion}</span>
            {it.confidence === "baja" && <span className="bg-amber-50 text-amber-600 px-1.5 rounded">estimado</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
